import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ServiceMessageType } from 'Components/Types';

interface ServiceMessageState {
    serviceMessages: ServiceMessageType[] | null;
}

const initialState: ServiceMessageState = {
    serviceMessages: null,
};

const serviceMessageSlice = createSlice({
    name: 'serviceMessages',
    initialState,
    reducers: {
        setServiceMessages(state:any, action: PayloadAction<ServiceMessageType|null>) {
            state.serviceMessages = action.payload;
        }
    }
});

export const { setServiceMessages } = serviceMessageSlice.actions;
export default serviceMessageSlice.reducer;